import { render, staticRenderFns } from "./request-education.vue?vue&type=template&id=4c3ed691&lang=pug&"
import script from "./request-education.vue?vue&type=script&lang=js&"
export * from "./request-education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports